import script from "./AbitCheckList.vue?vue&type=script&lang=ts&setup=true"
export * from "./AbitCheckList.vue?vue&type=script&lang=ts&setup=true"

import "./AbitCheckList.vue?vue&type=style&index=0&id=162378f4&scoped=true&lang=css"

import exportComponent from "/home/francesco/opt/abit/resources/js/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-162378f4"]])

export default __exports__